module.exports = "https://img.xiyuyouxi.com/saas/img/shop_tab2_bg_on.45a06435.png";